import { type MoneyMapRuleWithAccount } from '@fruitful/types';
import React from 'react';
import { View, YStack } from 'smoothie';

import {
    type BankAccountDisplayDetail,
    type DepositAccount,
    type IncomeSplitConfigLegacy,
    type PaycheckRoutingRuleAccountMetadata,
} from '../types/IncomeSplit';
import { getIncomeSplitAccountVisuals } from '../utils/incomeSplitAccountUtils';
import { getAccountFromRule } from '../utils/incomeSplitUtils';
import { IncomeSplitRuleCard } from './IncomeSplitRuleCard';

// Read only list of rules
export const IncomeSplitRulesList = ({
    incomeSplit,
    bankAccountDetails,
    externalAccounts,
    moneyMapRulesWithProposedAccounts,
    onBoxHeightChange,
}: {
    incomeSplit: IncomeSplitConfigLegacy;
    bankAccountDetails:
        | PaycheckRoutingRuleAccountMetadata[]
        | BankAccountDisplayDetail[]
        | DepositAccount[];
    externalAccounts?: DepositAccount[];
    moneyMapRulesWithProposedAccounts?: MoneyMapRuleWithAccount[];
    onBoxHeightChange?: (ruleId: string, height: number) => void;
}) => {
    const sortedRules = incomeSplit.rules.sort((a, b) => a.order - b.order);

    return (
        <YStack gap={16} flexGrow={1} flexShrink={1}>
            {sortedRules.map((rule) => {
                const account = getAccountFromRule(
                    rule,
                    bankAccountDetails,
                    externalAccounts ?? [],
                    moneyMapRulesWithProposedAccounts ?? [],
                );
                if (!account) return null;

                const { color, icon } = getIncomeSplitAccountVisuals(account);

                return (
                    <View
                        key={rule.id}
                        onLayout={(e) => {
                            const height = e.nativeEvent.layout.height;
                            if (onBoxHeightChange) {
                                onBoxHeightChange(rule.id, height);
                            }
                        }}
                    >
                        <IncomeSplitRuleCard
                            rule={rule}
                            account={account}
                            color={color}
                            icon={icon}
                            context="review"
                        />
                    </View>
                );
            })}
        </YStack>
    );
};
